<template>
    <v-select 
       :value="selected_wzct" 
       v-bind:items="changetypes"
       v-bind:rules="changeRules"
       item-value="code" 
       item-text="description" 
       :label="label"
       :dense="isDense"
       :clearable="isClearable"
       :multiple="isMultiple"
       @change="updateData">
        <template v-slot:selection="{ item, index }">
            <v-chip small v-if="index >= 0 && index < visibleChips">
                <span>{{ item.description }}</span>
            </v-chip>
            <span v-if="index === visibleChips" class="grey--text text-caption">(+{{ selected_wzct.length - visibleChips }})</span>
        </template>                                                        
     
    </v-select>
</template>

<script>
    export default {
        props: {
            selected_wzct: {
                type: Array,
                default: function() { return []; },
            },
            label: {
                type: String,
                default: 'Change type'
            },   
            field: {
                default: 'changetype',
                required: true,
            },
            isClearable:{
                type: Boolean,
                default: false
            },
            isMultiple:{
                type: Boolean,
                default: true
            },  
            isDense:{
                type: Boolean,
                default: true
            },
            visibleChips:{
                type: Number,
                default: 2
            }
        },
        data() {
            return {
                changeRules: [v => v.length !== 0 || "A value is required"],
                changetypes: [],
            }
        },
        created() {
            this.getChangeTypes();
        },
        methods: {
            getChangeTypes() {
                this.$axios.post("ares/json/ares/huov/howz/getWzct.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getWzct"
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.showDialog('error', 'Error', res.data.error.message);
                    } else {
                        this.changetypes = res.data.getWzct;
                    }
                })
            },
            updateData(v) {
                this.$emit('updateData', { field: this.field, value: v === null ? '' : v })
            }
        }
    }
</script>

<style scoped>

</style>